import { render, staticRenderFns } from "./TemplateVariables.vue?vue&type=template&id=2d8c4afd&scoped=true"
import script from "./TemplateVariables.vue?vue&type=script&lang=js"
export * from "./TemplateVariables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c4afd",
  null
  
)

export default component.exports